import React from "react";
import { useNavigate } from "react-router-dom";
import ContinueButton from "../../Registration/ContinueButton";
import graphicGif from "../../assets/Graphic.gif";

const RegistrationConfirmation = () => {
  const navigate = useNavigate();

  return (
    <section className=" w-full flex flex-col min-h-screen justify-start items-center py-10 px-6">
      <header className="mb-14">
        <h3 className="text-xl font-medium text-[#7E7E7E] text-center">
          Step 10
        </h3>
        <h1 className="text-2xl font-semibold text-[#1D2639] text-center">
          Registration Confirmation
        </h1>
        <p className="text-base font-medium text-[#7E7E7E] text-center w-full mt-2">
          Congratulations on completing your registration. You just joined the
          Early Access Party! We’ll send the access link once we go live. Thanks
          for signing up!
        </p>
      </header>
      <div className="p-6 max-w-md w-full flex flex-col items-center justify-center">
        {/* <div className="flex justify-center mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="248"
            height="248"
            viewBox="0 0 248 248"
            fill="none"
          >
            <path
              d="M124 15.5C152.776 15.5 180.373 26.9312 200.721 47.2789C221.069 67.6266 232.5 95.224 232.5 124C232.5 152.776 221.069 180.373 200.721 200.721C180.373 221.069 152.776 232.5 124 232.5C95.224 232.5 67.6266 221.069 47.2789 200.721C26.9312 180.373 15.5 152.776 15.5 124C15.5 95.224 26.9312 67.6266 47.2789 47.2789C67.6266 26.9312 95.224 15.5 124 15.5ZM110.484 145.405L86.3815 121.287C85.5174 120.423 84.4916 119.738 83.3627 119.27C82.2337 118.803 81.0237 118.562 79.8017 118.562C78.5798 118.562 77.3698 118.803 76.2408 119.27C75.1119 119.738 74.0861 120.423 73.222 121.287C71.4769 123.033 70.4966 125.399 70.4966 127.867C70.4966 130.335 71.4769 132.702 73.222 134.447L103.912 165.137C104.774 166.005 105.799 166.695 106.928 167.165C108.057 167.636 109.268 167.878 110.492 167.878C111.715 167.878 112.926 167.636 114.056 167.165C115.185 166.695 116.21 166.005 117.071 165.137L180.621 101.571C181.497 100.711 182.194 99.6857 182.671 98.5547C183.148 97.4236 183.397 96.2093 183.403 94.9816C183.409 93.754 183.171 92.5374 182.704 91.4019C182.237 90.2665 181.55 89.2347 180.683 88.3662C179.815 87.4976 178.784 86.8093 177.65 86.3412C176.515 85.873 175.298 85.6342 174.071 85.6384C172.843 85.6427 171.628 85.89 170.497 86.366C169.365 86.842 168.339 87.5374 167.478 88.412L110.484 145.405Z"
              fill="#0088FF"
            />
          </svg>
        </div> */}

        <div className="flex justify-center mb-4">
          <img
            src={graphicGif}
            alt="Graphic animation"
          />
        </div>

        <div className="flex flex-col justify-center items-center w-full sm:w-[572px]">
          <ContinueButton
            onClick={() => navigate("/")}
            label="Return to website"
          />
          {/* <button onClick={() => navigate("/buyer-profile-registration/invitation-page")} className="text-black text-base mt-4 font-medium">
            Invite team to platform
          </button> */}
        </div>
      </div>
    </section>
  );
};

export default RegistrationConfirmation;
